import React from "react";
import Icon from "./Icons";
import { l } from "../functions";

class TextField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isPassword: this.props.isPassword,
    };
  }

  render() {
    let {
      label,
      value,
      disabled,
      leftIcon,
      rightIcon,
      solid,
      size,
      isPassword,
      error,
      info,
      placeholder,
      multiline,
      align,
      onChange,
      dark,
      required,
      style = {},
    } = this.props;

    const id = "gk-" + Math.floor(Math.random() * 10000 + 1);

    if (!solid && error) rightIcon = <Icon icon="time" className="error" />;

    if (!solid && !error && value !== "")
      rightIcon = <Icon icon="check" className="check" />;

    if (isPassword)
      rightIcon = (
        <Icon
          onClick={() => {
            this.setState({ isPassword: !this.state.isPassword });
          }}
          icon={this.state.isPassword ? "eye" : "noeye"}
        />
      );

    let status = "";

    if (value === "" && required) error = "Empty field";

    if (error) status = "error";

    if (!error && value !== "") status = "done";

    return (
      <div className="gk-form-row">
        <div
          className={`gk-textfield ${status} ${size || "medium"} ${
            dark ? "dark" : ""
          }`}
        >
          {label && solid && <label htmlFor={id}>{label}</label>}
          <div
            className={`gk-field-container ${
              leftIcon !== "undefined" && "icon-left"
            } ${rightIcon !== "undefined" && "icon-right"}`}
          >
            {leftIcon && <span className="gk-left">{leftIcon}</span>}
            {(multiline && (
              <textarea
                id={id}
                value={value}
                disabled={disabled}
                placeholder={label || placeholder}
                onChange={(e) => {
                  onChange(e.target.value);
                }}
                className={`text-${align || "left"}`}
                style={style}
              />
            )) || (
              <input
                id={id}
                value={value}
                disabled={disabled}
                placeholder={label || placeholder}
                type={this.state.isPassword ? "password" : "text"}
                onChange={(e) => {
                  onChange(e.target.value);
                }}
                className={`text-${align || "left"}`}
              />
            )}
            {rightIcon && <span className="gk-right">{rightIcon}</span>}
          </div>
          {(solid || error || info) && (
            <span className="gk-descrption">
              {error && typeof error === "string" && error !== "" && (
                <Icon icon="close-circle" className="error" />
              )}
              {!error && value !== "" && (
                <Icon icon="check-circle" className="done" />
              )}
              {!error && info && value === "" && (
                <Icon icon="asterisk" className="info" />
              )}
              {error || (value === "" && info) || (value !== "" && "Valid!")}
            </span>
          )}
        </div>
      </div>
    );
  }
}

class Checkbox extends React.Component {
  render() {
    let { label, checked, disabled, onChange, size } = this.props;

    const id = "gk-" + Math.floor(Math.random() * 10000 + 1);

    return (
      <div className="gk-form-row">
        <div className={`gk-checkbox ${size || "small"}`}>
          <input
            id={id}
            type="checkbox"
            checked={checked}
            onChange={(event) => {
              onChange(event.target.checked);
            }}
            disabled={disabled}
          />
          <label htmlFor={id}>
            <span className={`gk-squarebox ${checked ? "checked" : ""}`}>
              <Icon icon="check" />
            </span>
            <span className="label">{label}</span>
          </label>
        </div>
      </div>
    );
  }
}

class Radio extends React.Component {
  render() {
    let { label, checked, disabled, onChange, size } = this.props;

    const id = "gk-" + Math.floor(Math.random() * 10000 + 1);

    return (
      <div className="gk-form-row">
        <div className={`gk-radio ${size || "small"}`}>
          <input
            id={id}
            type="radio"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
          />
          <label htmlFor={id}>
            <span className={`gk-circlebox ${checked ? "checked" : ""}`}>
              <Icon icon="dot" />
            </span>
            <span className="label">{label}</span>
          </label>
        </div>
      </div>
    );
  }
}

class Select extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drop: false,
    };
  }

  render() {
    let {
      value,
      options,
      disabled,
      uppercaseValue,
      placeholder,
      size,
      dark,
      pink,
      style,
      hardOptions,
      active,
      nullable,
      nullablePlaceholder,
    } = this.props;

    let currentOption;

    options.forEach((option) => {
      if (option.value == value) currentOption = option;
    });

    const contentValue =
      (value && currentOption && currentOption.label) ||
      placeholder ||
      l("Please select...");
    const contentProps = value && currentOption && currentOption.props;

    return (
      <div className="gk-form-row" style={style}>
        <input type="hidden" readOnly value={value || ""} />

        <div
          className={`gk-select ${size || "small"} ${dark ? "dark" : ""} ${
            pink ? "pink" : ""
          } ${active ? "active" : ""}`}
        >
          <div
            className={`gk-select-value ${this.state.drop ? "open" : ""} ${
              uppercaseValue ? "uppercase" : ""
            }`}
            onClick={() => {
              this.setState({ drop: !this.state.drop });
            }}
          >
            <span className="gk-value" {...contentProps}>
              {contentValue}
            </span>
            <Icon icon="dropdown-thin" />
          </div>
          {this.state.drop && (
            <div className={`gk-options ${hardOptions ? "hard-options" : ""}`}>
              {/* {placeholder && (
                <div
                  className="gk-option gk-placeholder"
                  onClick={() => {
                    if (nullable) this.props.onChange(null);
                  }}
                >
                  {nullable
                    ? nullablePlaceholder || l("Please select...")
                    : placeholder || l("Please select...")}
                </div>
              )} */}
              {options.map((option, key) => (
                <div
                  key={key}
                  className={`gk-option gk-placeholder ${
                    option.value == value ? "selected" : ""
                  }`}
                  onClick={() => {
                    this.setState({ drop: false }, () => {
                      this.props.onChange(option.value);
                    });
                  }}
                  {...option.props}
                >
                  {option.label}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

class SelectActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drop: false,
    };
  }

  render() {
    let {
      actions,
      uppercaseValue,
      placeholder,
      size,
      dark,
      pink,
      style,
      hardOptions,
      active,
    } = this.props;

    const contentValue = placeholder || l("Please select...");

    return (
      <div className="gk-form-row" style={style}>
        <div
          className={`gk-select ${size || "small"} ${dark ? "dark" : ""} ${
            pink ? "pink" : ""
          } ${active ? "active" : ""}`}
        >
          <div
            className={`gk-select-value ${this.state.drop ? "open" : ""} ${
              uppercaseValue ? "uppercase" : ""
            }`}
            onClick={() => {
              this.setState({ drop: !this.state.drop });
            }}
          >
            <span className="gk-value">{contentValue}</span>
            <Icon icon="dropdown-thin" />
          </div>
          {this.state.drop && (
            <div className={`gk-options ${hardOptions ? "hard-options" : ""}`}>
              {actions.map((action, key) => (
                <div
                  key={key}
                  className={`gk-option gk-placeholder ${
                    action.disabled ? "disabled" : ""
                  }`}
                  onClick={() => {
                    if (!action.disabled) {
                      this.setState({ drop: false }, () => {
                        action.action();
                      });
                    }
                  }}
                  {...action.props}
                >
                  {action.label}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export { TextField, Checkbox, Radio, Select, SelectActions };
